var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UsuarioViewModel = /** @class */ (function () {
    function UsuarioViewModel() {
        this.roles = new Array();
    }
    return UsuarioViewModel;
}());
export { UsuarioViewModel };
var NuevoUsuarioViewModel = /** @class */ (function (_super) {
    __extends(NuevoUsuarioViewModel, _super);
    function NuevoUsuarioViewModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NuevoUsuarioViewModel;
}(UsuarioViewModel));
export { NuevoUsuarioViewModel };
var NuevoPasswordViewModel = /** @class */ (function () {
    function NuevoPasswordViewModel() {
    }
    return NuevoPasswordViewModel;
}());
export { NuevoPasswordViewModel };
//# sourceMappingURL=UsuarioViewmodel.js.map


// WEBPACK FOOTER //
// UsuarioViewmodel.js